import styled from 'styled-components'

export default styled('div')`
  border-left: ${props => props.theme.border};
  border-right: ${props => props.theme.border};
  border-bottom: ${props => props.theme.border};

`
